export default "__VITE_ASSET__f04f4eb5__"